module.exports = __webpack_public_path__ + "static/media/bz.f6c04e11.svg";